// extracted by mini-css-extract-plugin
export default {"cls1":"Page-cls1__c5a684c76d4572b9d6ac","cls2":"Page-cls2__cd278126ba04d92341e9 Page-cls1__c5a684c76d4572b9d6ac"};